module.exports = __webpack_public_path__ + "assets/img/oa_log.97da43de.png";